import React from 'react'
import styled from 'styled-components'
import { media } from '../theme'

const Base = styled.p`
  font-family: ${(p) => p.theme.fontFamily.primary};
  font-size: ${(p) => p.theme.fontSize(p.large ? 2 : 1.5)};
  margin-bottom: ${(p) => (p.last ? 0 : p.theme.spacing(1))};
  text-align: ${(p) => p.textAlign};
  text-transform: ${(p) => (p.em ? 'uppercase' : 'none')};
  width: 100%;
  margin-top: ${(p) => p.marginTop || undefined};

  &:last-child {
    margin-bottom: 0;
  }

  a {
    color: #ffd98f;
  }
`

const Level1 = Base.extend`
  color: #fff;
`

const Level2 = Base.extend`
  color: #c9e9ea;
`

const Level3 = Base.extend`
  color: #76cdd9;
  font-size: ${(p) => p.theme.fontSize(1)};

  ${media.greaterThan('medium')`
    font-size: ${(p) => p.theme.fontSize(p.large ? 2 : 1.5)};
  `};
`

const comps = [Level1, Level2, Level3]

const Copy = ({
  children,
  level = 1,
  large = false,
  em = false,
  last = false,
  textAlign = 'center',
  ...props
}) => {
  const Comp = comps[level - 1]

  return (
    <Comp large={large} em={em} last={last} textAlign={textAlign} {...props}>
      {children}
    </Comp>
  )
}

export default Copy



// WEBPACK FOOTER //
// ./src/components/Copy.js